export default function getTooltipDirection(
  domRect: any,
  ref: any,
  tooltipPosition: any
) {
  const position = tooltipPosition ? tooltipPosition : "top";

  let top, left, positionClass;
  if (position == "left" || position == "right") {
    top = domRect?.top + domRect?.height / 2 - ref?.current?.clientHeight / 2;

    if (position == "left") {
      left = domRect?.left - ref?.current?.clientWidth - 10;
      positionClass = "cnv-tooltip-position-left";
    } else if (position == "right") {
      left = domRect?.right + 10;
      positionClass = "cnv-tooltip-position-right";
    }
  } else if (position == "top" || position == "bottom") {
    left = domRect?.left - ref?.current?.clientWidth / 2 + domRect?.width / 2;
    if (position == "top") {
      top = domRect?.top - ref?.current?.clientHeight - 10;
      positionClass = "cnv-tooltip-position-top";
    }
    if (position == "bottom") {
      top = domRect?.bottom + 10;
      positionClass = "cnv-tooltip-position-bottom";
    }
  }
  return { top, left, positionClass };
}
